import {
  selectError,
  selectIsLoading,
} from 'affiny-core/redux/selectors/asyncStateSelectors';
import { connect } from 'react-redux';
import { IRootState } from '../../state';
import { IAsyncStatusContainerFactoryOwnProps } from '../types';

const mapStateToProps = (
  state: IRootState,
  ownProps: IAsyncStatusContainerFactoryOwnProps
) => ({
  error: selectError(state, ownProps.asyncEventName),
  isLoading: selectIsLoading(state, ownProps.asyncEventName),
});

export type TAsyncStatusContainerProps = IAsyncStatusContainerFactoryOwnProps &
  ReturnType<typeof mapStateToProps>;

export const asyncStatusContainerFactory = connect(mapStateToProps);
